import styled from "styled-components";
import { OffCanvasAnimations } from ".";

export const Container = styled.div`
  position: fixed!important;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 99999;
  transition: ease-in all 0.2s;

  ${props => props.$isModal && `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2.5vh 2rem;
  `}

  ${(props) => props.$isOpen ?
    `
      visibility: visible;
      background-color: #0000002e;
    `
    :
    `
      visibility: hidden;
      transition: ease-in all 0.2s; 
    `
  } 

  @media screen and (max-width: 750px) {
    ${props => props.$isModal && `padding: 0;`}
  }
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.$backgroundColor || 'white'};
  position: fixed;
  top: 0;
  right: 0;
  z-index: 200;
  box-shadow: -2px 0 4px 0 #00000042;
  transition: ease-in all 0.2s;
  display: flex;
  flex-direction: column;

  ${props => props.$isModal && `
    position: relative;
    height: 95vh;
    max-width: calc(100vw - 4rem);
    box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);
    border: 1px solid rgba(255, 255, 255, 0.65);
    border-radius: 16px;
    overflow: hidden;
  `}

  ${props => props.$isOpen ? `
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transform: translate(0, 0);
  ` : `
      opacity: 0;
      visibility: hidden;
      pointer-events: none;

      ${!props.$isModal && `
        transform: translate${props.$typeAnimation === OffCanvasAnimations.Vertical ? 'X' : 'Y'}(${props.$width || '600px'});
      `}
  `}

  @media screen and (max-width: 750px){
    width: 100%;

    ${props => props.$isModal && `
      height: 100%;
      max-width: none;
      border: 0;
      border-radius: 0;
    `}
  }

  @media screen and (min-width: 750px){
   width: ${props => props.$width || '600px'};
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  min-height: 70px;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #ece8e2;
  background: white;
  z-index: 200;
  position: relative;

  ${props => props.$isModal && `
    border-radius: 16px 16px 0 0;
  `}
`

export const Body = styled.div`
  height: calc(100% - 110px);
  overflow: auto;
  padding: ${props => props.$paddingBody || '1rem'};
  background: ${props => props.$isModal ? '#f8f7f4' : 'white'};

  &::-webkit-scrollbar {
    width: 5px!important;
    height: 8px!important;
  }

  &::-webkit-scrollbar-track {
    background: whitesmoke!important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ff6200!important;
  }
`

export const Footer = styled.div`
  height: auto;
  min-height: 64px;
  padding: 0.8rem 1.25rem;
  border-top: 1px solid #e8e3dc;
  background: white;
  position: relative;
  display: flex;
  align-items: center;

  ${props => props.$isModal && `
    border-radius: 0 0 16px 16px;
  `}
`

export const ContainerTitleAndIcon = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
`

export const CloseIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`

export const TitleIcon = styled.span`
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  place-items: center;
  color: #f04b4b;
  border-radius: 11px;
  background: #fff0f0;
`

export const Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  transition: ease-in all 0.2s;
  padding: 0.3rem;

  &:hover {
    background-color: #cfd7e2;
  }
`

export const Title = styled.div`
  font-size: ${props => props.$fontSizeTitle || "var(--font-size-section-title)"};
  font-weight: 750;
  color: ${props => props.$colorTitle || "#121428"};
  width: 100%;
`

export const Subtitle = styled.p`
  font-size: var(--font-size-subtitle);
  font-weight: 600;
  margin: 0;
  color: #64748b;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  overflow: hidden;
`
